var scope_0 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0a8b4b2fe60d58d2f240eb9a44c95377.js').default;
var scope_1 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0bc769d9e7837ef9ab73b9a50bc46ace.js').default;
var scope_2 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/116aa98ab36cfdcd5fc88f6612e0065a.js').default;
var scope_3 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/11f51b1cd84c7a65d40a0bf492485b69.js').default;
var scope_4 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/19713ebafee986e08126ec0026a51dc9.js').default;
var scope_5 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/45d21972c3a13b8f31c89dfd28ba4edd.js').default;
var scope_6 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/49ce48243e81e2c764b34558406cdc81.js').default;
var scope_7 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/62f75a509eda5b42d2ca12f26bfa511e.js').default;
var scope_8 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/67bdfddd54b504cd2c5f012ac4f97b73.js').default;
var scope_9 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/71704f1e8263d43d671ab9c7889d1fc7.js').default;
var scope_10 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/735deb3b70eba8150e71019f8105ea8a.js').default;
var scope_11 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7f0d96f3ba48a280d643c2533f4c32a0.js').default;
var scope_12 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7f616d01dcf87aee41bb9e3c3e80ae72.js').default;
var scope_13 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/99fe5e4a3eaf4e6831f259096e739c47.js').default;
var scope_14 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b6fe58e678c2fff46f4ffde7296e82e3.js').default;
var scope_15 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d154fb5f9932754e8bbd33bebf2f9aff.js').default;
var scope_16 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d47a028997fda0133c4d45a699b8fa23.js').default;
var scope_17 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d5ce4079e6a50f0fbf913813535df795.js').default;
var scope_18 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e61f87b9e542e16aa59e08da76516343.js').default;
var scope_19 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e74c9fceaba949b5df7a12f433a66a26.js').default;
var scope_20 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e877cd767d30e73bf20c407a5f299b19.js').default;
var scope_21 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_22 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ed94c1636f6ec17647115ecc2509440f.js').default;
var scope_23 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f860ceb54b2c9728c8fe166669169c04.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16,
scope_17,
scope_18,
scope_19,
scope_20,
scope_21,
scope_22,
scope_23 )
    